import { useScanDataReimbursementsStoreLevelDetailsQuery } from '@occc/graphql';
import {
  usePaginatedQuery,
  PaginationInfo,
  PaginationHandler,
} from '@occc-app/hooks/usePaginatedQuery';

type UseScanDataReimbursementsStoreLevelDetailsParams = {
  submissionDateEquals: string;
  paginationInfo?: PaginationInfo;
  onPageChange?: PaginationHandler;
  search?: string;
};

export const useScanDataReimbursementsStoreLevelDetails = ({
  submissionDateEquals,
  paginationInfo,
  onPageChange,
  search,
}: UseScanDataReimbursementsStoreLevelDetailsParams) => {
  return usePaginatedQuery(
    useScanDataReimbursementsStoreLevelDetailsQuery,
    'scanDataReimbursementsStoreLevelDetails.pageInfo',
    undefined,
    {
      variables: {
        filter: {
          submissionDateEquals,
          siteAccountSubmitterSearch: search,
        },
      },
    },
    paginationInfo,
    onPageChange,
  );
};
